import { BaseModel } from '../../../common/base/model';

export class FeedbackModel extends BaseModel {
  constructor(data) {
    super(data, {
      rating: 0,
      message: '',
      orderId: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/feedback/feedback.model.js